// URL 및 도메인 유틸리티
export const getDomainInfo = () => {
  const hostname = window.location.hostname;
  const origin = window.location.origin;
  const isRender = hostname.includes('westory.onrender.com') || hostname.includes('onrender.com');
  const isLocal = hostname.includes('localhost') || hostname.includes('127.0.0.1');
  
  return {
    hostname,
    origin,
    isRender,
    isLocal,
    isProduction: isRender || (!isLocal && !hostname.includes('vercel'))
  };
};

export const getCorrectRedirectURL = () => {
  const domainInfo = getDomainInfo();
  
  // Render 환경에서는 항상 Render URL 사용
  if (domainInfo.isRender) {
    return 'https://westory.onrender.com/dashboard';
  }
  
  // 로컬 환경
  if (domainInfo.isLocal) {
    return `${domainInfo.origin}/dashboard`;
  }
  
  // 기타 프로덕션 환경 (Vercel 등)
  return `${domainInfo.origin}/dashboard`;
};

export const logRedirectInfo = () => {
  const domainInfo = getDomainInfo();
  const redirectURL = getCorrectRedirectURL();
  
  console.log('🔍 도메인 정보:', domainInfo);
  console.log('🎯 리다이렉트 URL:', redirectURL);
  
  return { domainInfo, redirectURL };
};